import axios from "axios";
import { del, get, post, put, patch } from "./role_permissions_api_helper";
import * as url from "./role_permissions_url_helper";







//======================== PERMISSIONS =======================================
export const getRolePermissions = () => get(url.GET_ROLE_PERMISSIONS);

// Add permission
export const addNewRolePermission = ({ role_id, permissions }) => post(url.ADD_NEW_ROLE_PERMISSION, { role_id, permissions });

// Update permission
//export const updateEvent = event => put(url.UPDATE_EVENT, event);
export const updateRolePermission = (role_id, permissions) => patch(`${url.UPDATE_ROLE_PERMISSION}/${rolePermission.uid}`,   { role_id, permissions  });


// Delete permission
//export const deleteEvent = event => del(url.DELETE_EVENT, { headers: { event } });
export const deleteRolePermission = rolePermission => del(`${url.DELETE_ROLE_PERMISSION}/${rolePermission}`);









export {
  //getLoggedInUser,
  
  
};
